var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSatNav32 = function SvgSatNav32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.29 23.887a11.785 11.785 0 0 1-5.292-5.592 11.326 11.326 0 0 1-.615-7.567A11.629 11.629 0 0 1 8.703 4.4 12.242 12.242 0 0 1 16.126 2c2.68.028 5.275.925 7.369 2.55a11.61 11.61 0 0 1 4.184 6.414 11.33 11.33 0 0 1-.779 7.553A11.806 11.806 0 0 1 21.49 24",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.216 14.241 7.73 15.065a.472.472 0 0 1-.1.566.486.486 0 0 1-.58.058l-7.5-4.474-7.024 4.431a.488.488 0 0 1-.578-.045.475.475 0 0 1-.118-.56L15.37 14.25a.48.48 0 0 1 .42-.251.488.488 0 0 1 .425.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 10 6 10M12 10 6 20M5 10h22",
    strokeLinecap: "round"
  }))));
};
export default SvgSatNav32;